import { useEffect } from "react";
import { SideNav } from "../shared-components/side-nav"
import { Col, Container } from "react-bootstrap";
import { Button, Card } from "@veneer/core";
import { Navigate, useNavigate } from "react-router-dom";
import "./occhat.css";
import { useTranslation } from "react-i18next";

const OcWidgetApiBaseDomain: string = (window as any).OcWidgetApiBaseDomain
  ? (window as any).OcWidgetApiBaseDomain
  : "";

const OcWidgetToken: string = (window as any).OcWidgetToken
  ? (window as any).OcWidgetToken
  : "";

const OcWidgetClientId: string = (window as any).OcWidgetClientId
  ? (window as any).OcWidgetClientId
  : "";

export const OcChat = ()=>{

  const navigate = useNavigate();
  const {t} = useTranslation();

    useEffect(() => {
        const hpi_Chat = JSON.parse(localStorage.getItem('hpi_Chat') || '{}');
        var chatWebComp:any;
        var script:any;
        var script2:any;
        const loadOmniChat = () => {
          if (!document.getElementById('chat-web-component')) {
            const omnichannelComp = document.createElement('omnichannel-chat-web-comp');
            chatWebComp = document.createElement('div');
            chatWebComp.appendChild(omnichannelComp);
            chatWebComp.setAttribute('id', 'chat-web-component');
            document.body.appendChild(chatWebComp);
          }
    
          script = document.createElement('script');
          script.textContent = `
            var omniChannelChatConfig = {
              cc: "${hpi_Chat.CountryCode.toLowerCase()}",
              lc: "${hpi_Chat.LanguageCode.toLowerCase()}",
              languageDirection: "ltr",
              apiBaseDomain: "${OcWidgetApiBaseDomain}",
              pageTitle: "MyHpSupport Chat",
              projectOriginFalcon: false,
              openOnLoad: true,
              token: "${OcWidgetToken}",
              clientId: "${OcWidgetClientId}",
              chatJWTToken: "${localStorage.getItem('hpi_ChatJWTToken')}",
              chatConfigObj: {
                CacheToken: { value: "${hpi_Chat.CacheToken}", isDisplayable: false },
                CaseID: { value: "${hpi_Chat.CaseNumber}", isDisplayable: false }
              }
            };
    
            var wrk = document.querySelector('omnichannel-chat-web-comp');
            wrk.omniChannelChatConfig = omniChannelChatConfig;
          `;
          document.body.appendChild(script);
    
          script2 = document.createElement('script');
          script2.src = `${OcWidgetApiBaseDomain}wcc-widgets/omni_cc/omni_app.js`;
          if (!isOmniChatScriptLoaded(`${OcWidgetApiBaseDomain}wcc-widgets/omni_cc/omni_app.js`)) {
            document.body.appendChild(script2);
          } else {
            document.getElementById('omnichat-initiator')?.click();
          }
    
          localStorage.setItem('hpi_ChatJWTToken', '');
        };
    
        const isOmniChatScriptLoaded = (url: string) => {
          const scripts = document.getElementsByTagName('script');
          for (let i = scripts.length; i--;) {
            if (scripts[i].src === url) return true;
          }
          return false;
        };
    
        loadOmniChat();
        return ()=>{
          document.body.removeChild(chatWebComp);
          document.body.removeChild(script);
          document.body.removeChild(script2);
          window.location.reload();
        }
      }, []);

      const myCases = ()=>{
        const Chat = JSON.parse(localStorage.getItem('hpi_Chat') || '{}');
        navigate(`/edit-case/?cid=${Chat.CaseId.replace('"','')}`);
      }

    return (
      <>
        <Container fluid className="bg-clr">
          <div className="initiate-Chat bg-clr">
            <div className="header">
              {/* <h2>{t('HPI.oochat.SupportText',{defltValue:'Start your chat online.'})}</h2> */}
              <Col className="supporting-text">
                <p>
                  {t('HPI.oochat.SupportText',{defltValue:'Start your chat online.'})}
                </p>
                {/* <span>
                <strong style={{ color: "red" }}>*</strong> Required fields
              </span> */}
              </Col>
            </div>

            <Card
              background="filled"
              customStyle={"background-color:transparent;"}
              className="pb-5 mt-3"
              content={
                <Container className="card-container top-0 chat-box-shadow d-flex flex-column gap-2 ">
                  <Button id="omnichat-initiator" style={{ display: 'none' }}>MS chat</Button>
            <div style={{ textAlign: 'center', lineHeight: '28px' }}>{t('HPI.oochat.ThankYouMessage',{defaultValue:'Thanks for starting your chat online.'})}</div>
            <div style={{ textAlign: 'center', lineHeight: '28px' }}>
            <Button
                  appearance="secondary"
                  onClick={myCases}
                >
                  {t('HPI.oochat.Dashboard',{defaultValue:'Go to your dashboard to see case details'})}
                </Button>
            </div>
                </Container>
              }
            />
            
          </div>
        </Container>
      </>
    );
};